import { API_URL } from '../../../../utils/config';

export const GET_PAID_CUSTOMERS_URL = `${API_URL}/users`;
export const ADD_LTE_USER_URL = `${API_URL}/open5gs`;
